import React, { useContext } from "react";
import "./HomePage.css";
import HeroSection from "../components/HeroSection";
import ServicesSection from "../components/ServicesSection";
import Seo from "../components/Seo";
import { LangContext } from "../lang/LangProvider";

const HomePage = () => {
  const { lang } = useContext(LangContext);
  return (
    <div className="home-page-root">
      <Seo
        title={lang === "en" ? "Financial education and quantitative finance models" : "Educazione finanziaria e modelli di finanza quantitativa"}
        description={
          lang === "en"
            ? "Financial education and quantitative finance models: articles, video series, backtests and simulation tools with stated assumptions."
            : "Educazione finanziaria e modelli di finanza quantitativa: articoli, serie video, backtest e strumenti di simulazione con ipotesi dichiarate."
        }
        path={`/${lang}/`}
        image="/assets/hero-social.jpg"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "AlphaFrame Analytics",
          url: "https://alphaweb-93f02.web.app",
          logo: "https://alphaweb-93f02.web.app/logo-512.png",
        }}
      />
      <HeroSection />
      <ServicesSection />
    </div>
  );
};

export default HomePage;
